const breadcrumbSchema = (items) => {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => {
      const listItem = {
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name
      };

      if (item.url) {
        listItem.item = item.url;
      }

      return listItem;
    })
  };
};

export default breadcrumbSchema;